<form [formGroup]="subscribeForm" (ngSubmit)="submitSubscriptionForm()">
  <div class="ui action fluid input">
    <input
      type="email"
      placeholder="Enter Email here"
      formControlName="emailId"
    />
    <button
      type="submit"
      class="ui icon button"
      [class.disabled]="subscribeForm.invalid || !showSubscriptionForm"
      [disabled]="
        subscribeForm.get('emailId').errors &&
        subscribeForm.get('emailId').errors?.email &&
        (subscribeForm.get('emailId').touched ||
          subscribeForm.get('emailId').dirty)
      "
    >
      <i class="paper plane icon"></i>
    </button>
  </div>
</form>
